import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { ChartsModule } from 'ng2-charts';

import { MaterialModule } from './material.module'

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './components/users/login.component';


import { HttpClientModule } from '@angular/common/http';
import { ReportsComponent } from './components/reports/reports.component';
import { MainComponent } from './components/template/main.component';
import { HeaderComponent } from './components/template/header/header.component';
import { FooterComponent } from './components/template/footer/footer.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { OrderEntryComponent } from './components/order-entry/order-entry/order-entry.component';
import { SearchOrdersComponent } from './components/order-entry/search-orders/search-orders.component';
import {httpInterceptorProviders} from './interceptors';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {PatientFormComponent} from './components/order-entry/order-entry/forms/patient-form/patient-form.component';
import {OrderEntryEditComponent} from './components/order-entry/order-entry-edit/order-entry-edit.component';
import { LoaderComponent } from './components/utils/loader/loader.component';

import { LoaderService } from './services/loader.service';
import { ConfigurationComponent } from './components/configuration/configuration.component';
import { ConfigurationModule } from './components/configuration/configuration.module';
import { ResultsDialog } from './components/reports/modals/results.component';
import { ResultsChart } from './components/reports/modals/results-chart.component';

import { InfoDialog } from './components/reports/modals/info.component';
import { PdfDialog } from './components/reports/modals/pdf.component';
import { HistoryDialog } from './components/reports/modals/history.component';
import { LabelsDialog } from './components/order-entry/order-entry/modals/labels.component';
import { LabelsInputDialog } from './components/order-entry/order-entry/modals/labels-input.component'
import { TestsDialog } from './components/order-entry/order-entry/modals/tests.component';
import { NotesDialog } from './components/order-entry/order-entry/modals/notes.component';

import { SelectionDialog } from './components/utils/group-selection/selection.component'
import { RemittancesComponent } from './components/order-entry/remittances/remittances.component';
import { DeleteOrderDialog } from './components/order-entry/remittances/modals/delete-order.component';
import { DeleteSampleDialog } from './components/order-entry/remittances/modals/delete-sample.component';
import { CreateRemittanceDialog } from './components/order-entry/remittances/modals/create-remittance.component';

import { CustomValidatorDirective } from './components/utils/validator/custom-validator.directive';
import { LoginDialog } from './components/utils/login-modal/login-dialog.component';
import { ConfirmDialog } from './components/utils/modals/confirm.component';
import { ResponseDialog } from './components/utils/modals/response.component';
import { NgxMatDatetimePickerModule, NgxMatNativeDateModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ReportsComponent,
    //PatientsComponent,
    MainComponent,
    HeaderComponent,
    FooterComponent,
    OrderEntryComponent,
    SearchOrdersComponent,
    PatientFormComponent,
    OrderEntryEditComponent,
    LoaderComponent,
    ResultsDialog,
    InfoDialog,
    PdfDialog,
    HistoryDialog,
    LabelsDialog,
    LabelsInputDialog,
    SelectionDialog,
    TestsDialog,
    RemittancesComponent,
    DeleteOrderDialog,
    DeleteSampleDialog,
    NotesDialog,
    CreateRemittanceDialog,
    CustomValidatorDirective,
    LoginDialog,
    ResultsChart,
    ConfirmDialog,
    ResponseDialog,
 ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        NgbModule,
        FormsModule,
        HttpClientModule,
        FontAwesomeModule,
        ChartsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        MaterialModule,
        NgxMatDatetimePickerModule,
        NgxMatTimepickerModule,
        NgxMatNativeDateModule
    ],
  providers: [
    httpInterceptorProviders,
    LoaderService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
